import { FilterOps, GQL_ID } from '@@types'

import { useFetchAllTextMaterials } from './useFetchAllTextMaterials'

interface RelatedBlogPostsProps {
  categorySlug?: string;
  themeSlug?: string;
  excludeId?: GQL_ID;
}

export function useRelatedBlogPosts ({
  categorySlug,
  themeSlug,
  excludeId
}: RelatedBlogPostsProps) {
  const { data, loading, error } = useFetchAllTextMaterials({
    filter: {
      and: [
        ...themeSlug ? [ {
          fields: [ 'themeSlug' ],
          op: FilterOps.CONTAINS,
          value: [ themeSlug ]
        } ] : [],
        ...categorySlug ? [ {
          fields: [ 'categorySlug' ],
          op: FilterOps.CONTAINS,
          value: [ categorySlug ]
        } ] : [],
        {
          fields: [ 'typeSlug' ],
          op: FilterOps.NOT_CONTAINS,
          value: [ 'static' ] // Exclude "static" type
        },
        {
          fields: [ 'id' ],
          op: excludeId ? FilterOps.NOT_CONTAINS : FilterOps.UNWRAP,
          value: [ excludeId || '' ]
        }
      ]
    }
  })

  return {
    data: data?.allTextMaterials?.edges ?? [],
    loading,
    error: error ? new Error(error.message) : undefined,
  }
};